import { jsx as _jsx } from "react/jsx-runtime";
import Alert from '@mui/material/Alert';
export default function LoadingErrorAnimation() {
    return (_jsx("div", Object.assign({ className: "d-flex align-items-center justify-content-center centeranimation ", style: { padding: '20%' } }, { children: _jsx(Alert, Object.assign({ variant: "filled", severity: "error" }, { children: "Erreur chargement des donn\u00E9es." })) })));
}
//# sourceMappingURL=LoadingErrorAnimation.js.map